import * as React from 'react';
import {observer} from "mobx-react-lite";
import {Link, useHistory} from "react-router-dom"
import {Container, Nav, Navbar, NavDropdown} from "react-bootstrap";
import {Ioc} from "../models/ioc";


const NavWrapper = observer(function Menu(props: any) {
    const history = useHistory()
    const showReportMenu = history.location.pathname.startsWith('/ioc/') || history.location.pathname === '/report'
    return <>
        <Navbar>
            <Container>
                <Nav activeKey={props.location.pathname}>
                    <Nav.Link as={Link} eventKey="/" to="/">Check another IOC</Nav.Link>
                    {showReportMenu && <Nav.Link as={Link} eventKey="/report" to="/report">Report False Positive</Nav.Link>}
                    {props.logsStore.data &&
                    <Nav.Link as={Link} eventKey="/logs" to="/logs">Check Log Results</Nav.Link>}
                    {props.iocStore.data.length !== 0 && (
                        <NavDropdown id="recent-requests-dropdown" className="navbar-dropdown"
                                     title="Recent Requests"
                                     active={history.location.pathname.startsWith('/ioc/')}>
                            {props.iocStore.data.map((v: Ioc) => (
                                <NavDropdown.Item
                                    key={v.ioc}
                                    as={Link}
                                    eventKey={"/ioc/" + v.ioc}
                                    to={"/ioc/" + v.ioc}
                                >{v.ioc}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    )}
                </Nav>
                <Navbar.Text className="text-right">The resulting information cannot be reused for commercial purposes without permission.</Navbar.Text>
            </Container>
        </Navbar>
        <Container className="main-content">
            {props.children}
        </Container>
    </>
});

export default NavWrapper